import Loadable from "app/components/Loadable";
import { lazy } from "react";

const Shop = Loadable(lazy(() => import("./Shop")));

const ecommerceRoutes = [
  { path: "/marketplace", element: <Shop /> },
];

export default ecommerceRoutes;
